export default "__VITE_ASSET__65e02e23__"